<template>
  <div id="app">
    <router-view />
  </div>
</template>





<style scoped lang="scss">
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>